var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionsEarn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_214_2480)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6592 13.7417C20.6641 12.001 17.5211 8.30414 12.6389 5.48527C7.75525 2.66645 2.98295 1.79263 1.97806 3.53324C1.41993 4.49728 0.863214 5.46273 0.306495 6.42819C-0.698399 8.16885 2.4446 11.8643 7.32821 14.6832C12.2105 17.502 16.9841 18.3773 17.9891 16.6366C18.5458 15.6711 19.1025 14.7071 19.6592 13.7417Z",
    fill: "#FE9923"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6591 13.7418C20.4259 12.4155 18.781 9.95184 15.7945 7.60799C14.9869 7.9843 14.1624 8.41275 13.3351 8.89054C10.4317 10.5664 8.07092 12.5156 6.64319 14.2759C6.8673 14.4141 7.09563 14.5494 7.32817 14.6832C10.0286 16.242 12.6952 17.2061 14.7093 17.4626C15.6113 17.0539 16.5359 16.5803 17.4647 16.0447C17.9241 15.7784 18.3695 15.5063 18.8008 15.2287L19.6591 13.7418Z",
    fill: "#CE7C1D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6389 5.48533C7.7552 2.66646 2.9829 1.79264 1.978 3.53325C0.97311 5.27246 4.11611 8.96936 8.99971 11.7882C13.882 14.6071 18.6556 15.4823 19.6592 13.7417C20.6641 12.0011 17.5211 8.30415 12.6389 5.48533Z",
    fill: "#FECD3D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.08704 11.8391C13.9397 14.617 18.6612 15.4711 19.6591 13.7418C20.4258 12.4155 18.781 9.95184 15.7945 7.60799C14.9869 7.9843 14.1623 8.41275 13.335 8.89054C11.7311 9.81514 10.2935 10.8243 9.08704 11.8391Z",
    fill: "#CEA732"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7877 6.95818C7.90331 4.71575 4.32057 3.64883 3.78498 4.57624C3.25079 5.50366 5.96533 8.07302 9.84971 10.3154C13.7341 12.5578 17.3168 13.6247 17.8524 12.6973C18.388 11.7713 15.672 9.20197 11.7877 6.95818Z",
    fill: "#FEA832"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5404 10.7031C14.1499 12.6777 17.3493 13.5698 17.8525 12.6974C18.2711 11.9716 16.6982 10.2394 14.1316 8.44517C13.8667 8.58894 13.6003 8.73693 13.3353 8.89053C12.3332 9.46843 11.3974 10.0787 10.5404 10.7031Z",
    fill: "#CE8829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 16.3069L15.2999 17.519C15.0025 17.5007 14.6854 17.4654 14.3541 17.4119L15.2449 15.8686L16.0003 16.3069ZM5.61996 13.6163C5.85817 13.777 6.10201 13.9362 6.35146 14.0927L7.16049 12.6917L6.40505 12.2576L5.61996 13.6163ZM0.885742 9.19636C1.05064 9.44587 1.23952 9.70235 1.45235 9.96309L2.34312 8.4212L1.58628 7.98427L0.885742 9.19636ZM3.10278 11.6671C3.31841 11.8588 3.54252 12.0519 3.77647 12.2435L4.62495 10.7749L3.86951 10.3408L3.10278 11.6671ZM8.32607 15.2343C8.58822 15.3711 8.84897 15.5035 9.1069 15.6289L9.89195 14.2703L9.13651 13.8319L8.32607 15.2343ZM11.2168 16.5394C11.5001 16.6466 11.7791 16.7438 12.0526 16.834L12.8193 15.5063L12.0639 15.0722L11.2168 16.5394Z",
    fill: "#C85929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.45865 14.4944V15.3767H3.34095V16.073H2.45865V16.9553H1.76243V16.073H0.880127V15.3767H1.76243V14.4944H2.45865Z",
    fill: "#FEA832"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0059 3.97312V4.85402H18.8882V5.55029H18.0059V6.43254H17.3097V5.55029H16.4274V4.85402H17.3097V3.97312H18.0059Z",
    fill: "#FEA832"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33953 18.3815C4.33459 16.6409 7.47904 12.9454 12.3612 10.1265C17.2435 7.30632 22.0172 6.43246 23.0221 8.17312C23.5788 9.13857 24.1355 10.1026 24.6937 11.0681C25.6986 12.8087 22.5542 16.5042 17.6719 19.3244C12.7883 22.1433 8.01604 23.0171 7.01109 21.2765C6.45437 20.3124 5.89625 19.347 5.33953 18.3815Z",
    fill: "#FE9923"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3612 10.1265C17.2435 7.30632 22.0172 6.43246 23.0221 8.17312C24.027 9.91373 20.8826 13.6092 16.0004 16.4281C11.1167 19.2483 6.34448 20.1222 5.33953 18.3815C4.33459 16.6409 7.47899 12.9454 12.3612 10.1265Z",
    fill: "#FECD3D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2112 11.5994C17.0955 9.35558 20.6797 8.29006 21.2139 9.21602C21.7494 10.1434 19.0349 12.7128 15.1491 14.9552C11.2648 17.199 7.68204 18.2645 7.14785 17.3385C6.61226 16.4112 9.3268 13.8418 13.2112 11.5994Z",
    fill: "#FEA832"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9362 19.712L13.7832 21.1791C13.4999 21.2863 13.2209 21.3849 12.946 21.4737L12.1793 20.146L12.9362 19.712ZM15.1081 18.91L15.8917 20.2687C16.1511 20.1432 16.4118 20.0122 16.6726 19.8741L15.8635 18.4731L15.1081 18.91ZM8.99963 20.9466L9.69867 22.1587C9.9975 22.1418 10.3132 22.1052 10.6458 22.0516L9.75502 20.5097L8.99963 20.9466ZM23.4123 12.624L22.6569 13.061L23.5462 14.6028C23.759 14.3422 23.9493 14.087 24.1128 13.8375L23.4123 12.624ZM17.8395 17.3315L18.6485 18.7339C18.898 18.576 19.1418 18.4168 19.38 18.2561L18.595 16.8974L17.8395 17.3315ZM20.3751 15.4146L21.2236 16.8847C21.4575 16.6916 21.6816 16.4999 21.8958 16.3068L21.1305 14.9806L20.3751 15.4146Z",
    fill: "#C85929"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_214_2480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.8098,
    height: 24.8098,
    fill: "white",
    transform: "translate(0.0950928)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionsEarn);
export default __webpack_public_path__ + "static/media/actions-earn.158f5a30f2881159886812167d46e70e.svg";
export { ForwardRef as ReactComponent };